export const validateFields = (fields: Record<string, any>): boolean => {
  return !Object.values(fields).some(value => !value);
};
